(() => {
  const register = (name, initializer) => {
    if (window.SafeWalkV51Product?.register) window.SafeWalkV51Product.register(name, initializer);
    else (window.SafeWalkV51ProductQueue ||= []).push([name, initializer]);
  };

  register('sticky', ({ root, listen, addCleanup }) => {
    const mobileSticky = root.querySelector('[data-mobile-atc], .swv5-mobile-atc');
    const desktopSticky = root.querySelector('[data-desktop-atc]');
    const whatsapp = root.querySelector('.swv5-wa-float');
    if (!mobileSticky && !desktopSticky && !whatsapp) return;
    let footerVisible = false;
    const setVisibility = (sticky, visible) => {
      if (!sticky) return;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.toggleAttribute('inert', !visible);
      sticky.querySelectorAll('[data-swv5-submit]').forEach((button) => {
        if (visible) button.removeAttribute('tabindex');
        else button.setAttribute('tabindex', '-1');
      });
    };
    const update = () => {
      const mobileViewport = window.matchMedia('(max-width: 989px)').matches;
      document.body.classList.toggle('swv5-mobile-floats-ready', !mobileViewport || window.scrollY > 520);
      const atcs = Array.from(root.querySelectorAll('[data-atc]'));
      if (atcs.length === 0) {
        setVisibility(desktopSticky, false);
        setVisibility(mobileSticky, false);
        document.body.classList.remove('swv5-mobile-atc-visible');
        document.body.classList.remove('swv5-primary-atc-visible');
        return;
      }
      const atcVisible = atcs.some((button) => {
        if (button.getClientRects().length === 0) return false;
        const buttonRect = button.getBoundingClientRect();
        return buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
      });
      const primaryAtcPassed = atcs.some((button) => {
        if (button.getClientRects().length === 0) return false;
        return button.getBoundingClientRect().bottom <= 0;
      });
      document.body.classList.toggle(
        'swv5-primary-atc-visible',
        mobileViewport && window.scrollY > 520 && atcVisible,
      );
      if (desktopSticky) {
        const desktopViewport = window.matchMedia('(min-width: 990px)').matches;
        const closingBand = document.querySelector('.fp-closing');
        const closingRect = closingBand?.getBoundingClientRect();
        const closingTakesOver = Boolean(closingRect && closingRect.top < window.innerHeight * 0.82);
        setVisibility(desktopSticky, desktopViewport && window.scrollY > 360 && primaryAtcPassed && !atcVisible && !closingTakesOver && !footerVisible);
      }
      const openPersonalization = root.querySelector('.swv51-personalization[open]');
      const personalizationRect = openPersonalization?.getBoundingClientRect();
      const personalizationVisible = Boolean(
        personalizationRect &&
        personalizationRect.top < window.innerHeight &&
        personalizationRect.bottom > 0
      );
      const showMobile = Boolean(
        mobileSticky &&
        mobileViewport &&
        window.scrollY > 520 &&
        primaryAtcPassed &&
        !atcVisible &&
        !footerVisible &&
        !personalizationVisible
      );
      setVisibility(mobileSticky, showMobile);
      document.body.classList.toggle('swv5-mobile-atc-visible', showMobile);
    };
    listen(window, 'scroll', update, { passive: true });
    listen(window, 'resize', update);
    const config = root.querySelector('.swv5-config');
    if (config) listen(config, 'toggle', update, true);
    if (config && 'ResizeObserver' in window) {
      const layoutObserver = new ResizeObserver(update);
      layoutObserver.observe(config);
      addCleanup(() => layoutObserver.disconnect());
    }
    if (config && 'MutationObserver' in window) {
      const contentObserver = new MutationObserver(update);
      contentObserver.observe(config, { childList: true, subtree: true });
      addCleanup(() => contentObserver.disconnect());
    }
    const footer = document.querySelector('footer.footer, .fp-footer');
    if (footer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        update();
      });
      observer.observe(footer);
      addCleanup(() => observer.disconnect());
    }
    update();

    return () => {
      setVisibility(desktopSticky, false);
      setVisibility(mobileSticky, false);
      document.body.classList.remove('swv5-mobile-atc-visible');
      document.body.classList.remove('swv5-primary-atc-visible');
      document.body.classList.remove('swv5-mobile-floats-ready');
    };
  });
})();
